import dayjs, { Dayjs } from 'dayjs';
import { useTranslation } from 'react-i18next';
import { CustomDatePicker } from '~/components/Shared/CustomDatePicker/CustomDatePicker';
import CustomQuerySelect from '~/components/Shared/CustomQuerySelect/CustomQuerySelect';
import { useDebounce } from '@uidotdev/usehooks';
import styles from './FeedbacksReportExtra.module.scss';

interface IAccommodation {
  id: number;
  name: string;
}

interface FeedbacksReportExtraProps {
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
  accommodations: IAccommodation[];
  onAccommodationsChange: (value: IAccommodation[]) => void;
  isAllAccommodationChecked: boolean;
  onAllAccommodationChange: (value: boolean) => void;
}

export const FeedbacksReportExtra = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  accommodations,
  onAccommodationsChange,
  isAllAccommodationChecked,
  onAllAccommodationChange,
}: FeedbacksReportExtraProps) => {
  const { t } = useTranslation();
  const debouncedSearchTerm = useDebounce('', 500);

  const params = {
    sort: '',
    perPage: 100,
    field: '',
    query: debouncedSearchTerm,
    page: 1,
  };

  const disabledDate = (current: Dayjs) => {
    return current && current > dayjs().endOf('day');
  };

  return (
    <div>
      <CustomQuerySelect
        label={t('object')}
        query="admin/accommodations"
        queryKey={['accommodations', params]}
        placeholder={t('accommodations_validate')}
        params={params}
        value={accommodations}
        onChange={(value) => {
          if (Array.isArray(value)) {
            onAccommodationsChange(value);
          }
        }}
        required
        disabled={isAllAccommodationChecked}
        multiselect
        isSearchEnabled
        hasCheckbox
        checkboxLabel={t('all_accommodation_selection')}
        setIsCheckedAll={(value) => onAllAccommodationChange(value)}
      />

      <div className={styles.dateWrapper}>
        <span className={styles.labelText}>
          {t('date')}
          <span className={styles.labelStar}>*</span>
        </span>
        <CustomDatePicker
          value={[startDate, endDate]}
          showPresets={true}
          placeholder={[t('date_from'), t('date_by')]}
          disabledDate={disabledDate}
          onChange={(name, value) => {
            if (name === 'start_date') {
              onStartDateChange(value);
            } else if (name === 'end_date') {
              onEndDateChange(value);
            }
          }}
        />
      </div>
    </div>
  );
};
